import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import FormikActions from "../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../commons/formik/FormikAutocomplete";
import { StyledResolucion } from "../../../../styled/Prevencion";
import { medidasPreventivasValidation } from "../puestosValidations";

const MedidasPreventivasForm = ({ open, handleClose, handleSubmit, initialValues, selectedOptions }) => {
  const medidasPreventivas = useSelector((state) => state.resolucion.medidasPreventivas.data)
  const dispatch = useDispatch();

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        Agregar Medida Preventiva
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={medidasPreventivasValidation(selectedOptions)}
      >
        {() => (
          <Form>
            <DialogContent>
              <Grid container>
                <StyledResolucion.DialogGridItem item xs={12}>
                  <FormikAutocomplete
                    name="idMedidaPreventiva"
                    label="Medida Preventiva"
                    options={medidasPreventivas}

                    fullWidth
                  //getOptions={() => dispatch(getmedidasPreventivas())}
                  />
                </StyledResolucion.DialogGridItem>
              </Grid>
            </DialogContent>

            <DialogActions>
              <FormikActions handleCancel={handleClose} />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default MedidasPreventivasForm;
